import type { LegalDocument } from '../types';

/** Источник: «Согласие на обработку персональных данных.docx». Файл сгенерирован — правки вносите в документ. */
export const doc: LegalDocument = {
  title: 'Согласие на обработку персональных данных',
  blocks: [
    {
      kind: 'para',
      number: '1.',
      text: 'Настоящий документ является публичной офертой (далее — Оферта) ООО «Falcon» (ОГРН 108РА000782, ИНН 11008213, юридический адрес: проспект Мира 16, г. Сухум, Республика Абхазия) (далее — Компания) и определяет условия предоставления Пользователем согласия на обработку его персональных данных.',
    },
    {
      kind: 'para',
      number: '2.',
      text: 'Акцептом настоящей Оферты является регистрация Пользователя в мобильном приложении Aura, а также использование его функций, сервисов и инструментов. Совершая акцепт, Пользователь считается предоставившим Компании согласие на обработку его персональных данных на условиях, изложенных ниже.',
    },
    {
      kind: 'para',
      number: '3.',
      text: 'Компания обрабатывает персональные данные Пользователей в следующих целях:',
    },
    {
      kind: 'bullet',
      text: 'регистрация и идентификация Пользователя в Приложении;',
    },
    {
      kind: 'bullet',
      text: 'предоставление доступа к функциональным возможностям, включая коммуникацию, публикацию контента, участие в мероприятиях, использование виртуальной валюты и платных функций;',
    },
    {
      kind: 'bullet',
      text: 'исполнение обязательств Компании по Пользовательскому соглашению;',
    },
    {
      kind: 'bullet',
      text: 'направление уведомлений, сообщений и рассылок, связанных с использованием Приложения;',
    },
    {
      kind: 'bullet',
      text: 'соблюдение требований законодательства Республики Абхазия, Российской Федерации, стран СНГ и международных стандартов в области защиты персональных данных.',
    },
    {
      kind: 'para',
      number: '4.',
      text: 'В рамках настоящей Оферты Компания осуществляет сбор, хранение, систематизацию, накопление, уточнение, использование, передачу, обезличивание и удаление следующих категорий персональных данных Пользователя:',
    },
    {
      kind: 'bullet',
      text: '(a) регистрационные данные — фамилия, имя, дата рождения, адрес электронной почты, номер телефона, фотография профиля, сведения о гражданстве и национальности;',
    },
    {
      kind: 'bullet',
      text: '(b) данные, добровольно предоставленные Пользователем при заполнении анкет, участии в мероприятиях, публикации материалов, комментариев, сообщений, использовании разделов приложения;',
    },
    {
      kind: 'bullet',
      text: '(c) технические данные, автоматически передаваемые устройством Пользователя при использовании приложения: IP-адрес, тип и модель устройства, версия операционной системы, язык интерфейса, время доступа к сервисам, сведения о сбоях, а также файлы cookie;',
    },
    {
      kind: 'bullet',
      text: '(d) данные о действиях Пользователя: настройки, история взаимодействия, активность на карте, использование виртуальной валюты и платных функций;',
    },
    {
      kind: 'bullet',
      text: '(e) данные, предоставленные при проверке личности, включая документы, фотографии и видеозаписи (в случаях, когда это необходимо для предоставления определенных функций приложения);',
    },
    {
      kind: 'bullet',
      text: '(f) данные о платежах, совершаемых через сторонние платежные системы (App Store, Google Play, ЮKassa), без сохранения реквизитов платежных карт.',
    },
    {
      kind: 'para',
      number: '5.',
      text: 'Обработка персональных данных осуществляется с использованием средств автоматизации и без таковых, с соблюдением принципов законности, справедливости и минимизации.',
    },
    {
      kind: 'para',
      number: '6.',
      text: 'Компания принимает все необходимые организационные и технические меры для защиты персональных данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования, распространения и иных неправомерных действий.',
    },
    {
      kind: 'para',
      number: '7.',
      text: 'Персональные данные Пользователей, являющихся гражданами Республики Абхазия, хранятся на серверах, расположенных на территории Республики Абхазия или Российской Федерации. В соответствии с требованиями законодательства Республики Абхазия или Российской Федерации соответственно.',
    },
    {
      kind: 'para',
      number: '8.',
      text: 'Настоящее согласие предоставляется на срок действия Пользовательского соглашения и сохраняет силу в течение тридцати календарных дней после удаления учетной записи Пользователя из приложения, если иное не предусмотрено законом или не требуется для разрешения возможных споров.',
    },
    {
      kind: 'para',
      number: '9.',
      text: 'Пользователь имеет право:',
    },
    {
      kind: 'bullet',
      text: '(a) получать информацию об обработке своих персональных данных, включая подтверждение факта обработки, цели, правовые основания и способы обработки;',
    },
    {
      kind: 'bullet',
      text: '(b) требовать уточнения, блокирования или удаления своих персональных данных, если они являются неполными, устаревшими, недостоверными, незаконно полученными или не необходимы для заявленных целей обработки;',
    },
    {
      kind: 'bullet',
      text: '(c) отозвать согласие на обработку персональных данных;',
    },
    {
      kind: 'bullet',
      text: '(d) обжаловать действия или бездействие Компании в уполномоченные органы или суд в случае нарушения его прав;',
    },
    {
      kind: 'bullet',
      text: '(e) требовать прекращения передачи данных третьим лицам, за исключением случаев, предусмотренных законом или договором.',
    },
    {
      kind: 'para',
      number: '10.',
      text: 'Согласие может быть отозвано путем направления письменного уведомления на адрес электронной почты support@aura-vibe.site или через встроенную контактную форму в приложении. Компания обязуется прекратить обработку и удалить данные Пользователя в течение 30 календарных дней с момента получения такого уведомления, за исключением случаев, когда хранение данных требуется по закону или для исполнения договорных обязательств.',
    },
    {
      kind: 'para',
      number: '11.',
      text: 'Отзыв согласия может повлечь ограничение доступа к функциональным возможностям приложения, включая невозможность использования отдельных сервисов, требующих идентификации или авторизации Пользователя.',
    },
    {
      kind: 'para',
      number: '12.',
      text: 'Продолжая использование приложения, Пользователь подтверждает, что ознакомлен с условиями настоящей Оферты и Политикой конфиденциальности, и выражает свое осознанное согласие на обработку персональных данных на указанных условиях.',
    },
    {
      kind: 'para',
      number: '13.',
      text: 'Настоящая Оферта находится в открытом доступе в мобильном приложении и на веб-сайте Компании. Компания вправе вносить изменения в текст Оферты, уведомляя Пользователя о таких изменениях посредством push-уведомления в приложении или иным электронным способом. Новая редакция Оферты вступает в силу с момента ее опубликования, если иное не указано в уведомлении.',
    },
    {
      kind: 'para',
      number: '14.',
      text: 'Компания осуществляет обработку персональных данных в соответствии с Политикой конфиденциальности, размещенной по адресу: https://aura-vibe.site/privacy_policy. Если Пользователь является гражданином Республики Абхазия, Российской Федерации и стран СНГ, обработка его персональных данных осуществляется в соответствии с Политикой конфиденциальности, размещенной по адресу: https://aura-vibe.site/privacy_policy.',
    },
    {
      kind: 'para',
      number: '15.',
      text: 'Акцепт настоящей Оферты и согласие на обработку персональных данных выражается одним из следующих действий Пользователя:',
    },
    {
      kind: 'bullet',
      text: '(a) нажатие кнопки «», «», «» или иной аналогичной кнопки при установке, регистрации или первом запуске приложения;',
    },
    {
      kind: 'bullet',
      text: '(b) установка отметки в поле «Я согласен с условиями обработки персональных данных» при заполнении регистрационной формы;',
    },
    {
      kind: 'bullet',
      text: '(c) продолжение использования приложения после ознакомления с текстом настоящей Оферты.',
    },
    {
      kind: 'para',
      number: '16.',
      text: 'При акцепте настоящей Оферты Пользователь считается надлежащим образом уведомленным о целях, способах и условиях обработки персональных данных, а также о правах, предусмотренных законодательством Республики Абхазия, Российской Федерации, стран СНГ и международными стандартами защиты данных.',
    },
    {
      kind: 'para',
      number: '17.',
      text: 'Персональные данные могут быть переданы и обработаны на территории Республики Абхазия, где зарегистрирована Компания, исключительно в целях исполнения договора между Пользователем и Компанией, а также для обеспечения функционирования мобильного приложения. Акцептуя настоящую Оферту, Пользователь выражает свое письменное согласие на такую трансграничную передачу и подтверждает, что осведомлен о возможных рисках, связанных с обработкой данных в иностранных юрисдикциях, которые не обеспечивают уровень защиты, эквивалентный уровню защиты, предусмотренному законодательством Республики Абхазия и Российской Федерации.',
    },
  ],
};
